import { AxiosError } from 'axios';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ErrorInfo } from '../../api/model';
import OkModal from './OkModal';
import SpinnerModal from './SpinnerModal';

interface Props {
  onClickOk?: () => void | undefined;
  error: AxiosError<Blob> | null;
}

/**
 * ファイルダウンロード時など返り値が Blob 型になっているときに利用するエラー表示用モーダル
 * @param param0
 * @returns
 */
function BlobErrorModal({ onClickOk, error }: Props) {
  const { t } = useTranslation();
  const [errorInfo, setErrorInfo] = useState<ErrorInfo | null>();

  useEffect(() => {
    if (error == null || error.response == null) {
      setErrorInfo(null);
      return;
    }
    const { response } = error;
    const asyncFunc = async () => {
      const blobText = await response.data.text();
      setErrorInfo(JSON.parse(blobText) as ErrorInfo);
    };
    void asyncFunc();
  }, [error]);

  if (typeof errorInfo === 'undefined') {
    return <SpinnerModal />;
  }

  return (
    <OkModal onClickOk={onClickOk}>
      <div>{t('エラーが発生しました。')}</div>
      <div>
        <p>■{t('ステータス')}</p>
        <p className="mt5">
          <span>{error?.response?.status ?? t('不明')}</span>
          <span className="ml10">{error?.response?.statusText ?? t('不明')}</span>
        </p>
      </div>
      <div>
        <p>■{t('エラーコード')}</p>
        <p className="mt5">{errorInfo?.error_code ?? t('不明')}</p>
      </div>
      <div>
        <p>■{t('エラーメッセージ')}</p>
        <p className="mt5">{errorInfo?.message ?? t('不明なエラー')}</p>
      </div>
      <div>
        <p>■{t('詳細情報')}</p>
        <p className="mt5">{errorInfo?.debug_info ?? t('特になし')}</p>
      </div>
    </OkModal>
  );
}

BlobErrorModal.defaultProps = {
  onClickOk: undefined,
};


export default BlobErrorModal;
